import React from "react";

// Brand nav icons (AgencyMinder). Each is a drop-in for react-icons: takes size/color from the
// <Icon> wrapper and paints with currentColor so it inherits nav active/hover color like the Fi* set.
const BrandIcon = ({ viewBox, size = 24, color, style, children, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={viewBox}
    color={color}
    style={style}
    {...rest}
  >
    {children}
  </svg>
);

export const HomeIcon = (props) => (
  <BrandIcon viewBox="0 0 15 13" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path d="M13.5 13H8.625c-.276 0-.5-.228-.5-.51V9.31h-1.25v3.18c0 .282-.224.51-.5.51H1.5c-.276 0-.5-.228-.5-.51V6.51c0-.282.224-.51.5-.51s.5.228.5.51v5.472h3.875V8.8c0-.281.224-.51.5-.51h2.25c.276 0 .5.229.5.51v3.182H13V6.509c0-.281.224-.509.5-.509s.5.228.5.51v5.98c0 .282-.224.51-.5.51" />
      <path d="M.448 7c-.126 0-.252-.054-.34-.158-.161-.19-.139-.475.049-.637L7.237.108c.168-.144.416-.144.583.001l7.024 6.097c.188.163.209.448.048.637-.162.189-.444.21-.632.048L7.527 1.046.739 6.893C.654 6.965.55 7 .448 7" />
    </g>
  </BrandIcon>
);

export const ContractIcon = (props) => (
  <BrandIcon viewBox="0 0 14 17" {...props}>
    <g fill="none" fillRule="evenodd" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
      <path d="M7.5 0h-6C.672 0 0 .672 0 1.5v12c0 .828.672 1.5 1.5 1.5h9c.828 0 1.5-.672 1.5-1.5v-9L7.5 0z" transform="translate(1 1)" />
      <path d="M7 0L7 5 12 5M9 8.5H3M9 11.5H3M5 5.5L4 5.5 3 5.5" transform="translate(1 1)" />
    </g>
  </BrandIcon>
);

export const ProfileIcon = (props) => (
  <BrandIcon viewBox="0 0 15 19" {...props}>
    <path fill="currentColor" fillRule="evenodd" d="M7.47 10.708c1.772.001 3.357.71 4.516 1.952 1.06 1.138 1.754 2.732 1.865 4.658H1.091c.11-1.926.806-3.52 1.865-4.658 1.159-1.241 2.744-1.95 4.515-1.952M3.388 5.15c0-1.129.457-2.146 1.196-2.887.74-.74 1.758-1.195 2.887-1.195s2.146.456 2.886 1.195c.74.74 1.196 1.758 1.196 2.887 0 1.13-.456 2.147-1.196 2.887-.74.74-1.757 1.195-2.886 1.196-1.13 0-2.146-.457-2.887-1.196-.74-.74-1.195-1.758-1.196-2.887M0 17.851c0 .14.057.278.157.378.099.1.236.156.377.156h13.874c.14 0 .278-.057.377-.156.1-.1.157-.237.157-.378 0-2.41-.821-4.467-2.175-5.919-.908-.975-2.058-1.666-3.337-2.02 1.872-.771 3.19-2.611 3.19-4.762C12.62 2.306 10.316 0 7.47 0 4.628 0 2.322 2.305 2.32 5.15c0 2.15 1.32 3.991 3.192 4.762-1.28.354-2.43 1.045-3.337 2.02C.821 13.384 0 15.442 0 17.852" />
  </BrandIcon>
);

// Brand "exit" is a rotated "+" (an ×). Rendered as crossed strokes so it themes with currentColor
// and doesn't depend on the Filson font being loaded.
export const ExitIcon = (props) => (
  <BrandIcon viewBox="0 0 24 24" {...props}>
    <path fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" d="M6 6L18 18M18 6L6 18" />
  </BrandIcon>
);

// Two-color badge: lemon circle + eggplant "i" (brand info.svg). Self-colored.
export const InfoIcon = (props) => (
  <BrandIcon viewBox="0 0 11 11" {...props}>
    <g fill="none" fillRule="evenodd">
      <circle cx="5.5" cy="5.5" r="5.5" fill="#EFEC74" />
      <g fill="#1A0F33" transform="translate(5 2)">
        <path d="M.714 6.592C.33 6.592.02 6.282.02 5.9v-2.84c0-.383.31-.693.694-.693.382 0 .693.31.693.693v2.84c0 .382-.31.693-.693.693M1.428.714c0 .394-.32.714-.714.714C.32 1.428 0 1.108 0 .714 0 .32.32 0 .714 0c.394 0 .714.32.714.714" />
      </g>
    </g>
  </BrandIcon>
);

// Two-color badge: red disc + white plus (brand red.svg). Self-colored; plus drawn as strokes
// so it doesn't depend on the Montserrat font the source SVG used for the "+" glyph.
export const AddIcon = (props) => (
  <BrandIcon viewBox="0 0 16 16" {...props}>
    <circle cx="8" cy="8" r="8" fill="#ED343E" />
    <path stroke="#FFF" strokeWidth="1.6" strokeLinecap="round" d="M8 4.5v7M4.5 8h7" />
  </BrandIcon>
);

// Two-color badge: orange disc + white pencil. Self-colored, so it ignores currentColor.
export const EditIcon = (props) => (
  <BrandIcon viewBox="0 0 17 17" {...props}>
    <g fill="none" fillRule="evenodd">
      <circle cx="8.5" cy="8.5" r="8.5" fill="#F9A11B" />
      <path
        stroke="#FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10.295 5.292c.253-.252.62-.35.965-.258.344.092.614.362.706.706.092.345-.006.712-.258.965L6.942 11.47 5 12l.53-1.942 4.765-4.766z"
      />
    </g>
  </BrandIcon>
);
